var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.83838 8C1.83838 6.93689 2.59397 5.91133 4.00832 5.10286C5.40085 4.30688 7.25509 3.83838 9 3.83838C10.7449 3.83838 12.5991 4.30687 13.9917 5.10286C15.406 5.91133 16.1616 6.93689 16.1616 8C16.1616 9.06312 15.406 10.0887 13.9917 10.8971C12.5991 11.6931 10.7449 12.1616 9 12.1616C7.25508 12.1616 5.40084 11.6931 4.00832 10.8971C2.59397 10.0887 1.83838 9.06312 1.83838 8ZM9 2.16162C6.99095 2.16162 4.84519 2.69313 3.17621 3.64714C1.52905 4.58868 0.161621 6.06312 0.161621 8C0.161621 9.93689 1.52905 11.4113 3.17621 12.3529C4.84518 13.3069 6.99095 13.8384 9 13.8384C11.009 13.8384 13.1548 13.3069 14.8238 12.3529C16.4709 11.4113 17.8384 9.93689 17.8384 8C17.8384 6.06312 16.4709 4.58868 14.8238 3.64714C13.1548 2.69313 11.009 2.16162 9 2.16162ZM7.56613 8.16713C7.56613 7.35193 8.22694 6.69113 9.04216 6.69113C9.85731 6.69113 10.5182 7.35194 10.5182 8.16713C10.5182 8.98232 9.85731 9.64313 9.04216 9.64313C8.22694 9.64313 7.56613 8.98232 7.56613 8.16713ZM9.04216 5.21513C7.41179 5.21513 6.09013 6.53674 6.09013 8.16713C6.09013 9.79752 7.41179 11.1191 9.04216 11.1191C10.6724 11.1191 11.9942 9.79752 11.9942 8.16713C11.9942 6.53673 10.6724 5.21513 9.04216 5.21513Z",
    fill: "#908C95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEye);
export default __webpack_public_path__ + "static/media/open_eye.c8481ee2c5f7bcc001925e6f48a17441.svg";
export { ForwardRef as ReactComponent };